var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":"/resume"}},[_vm._v("新竹縣防災人員"),_c('span',[_vm._v("教育訓練暨學習履歷平台")])])])])}]

export { render, staticRenderFns }